import Module from '../../module';
import sliderListCutFactory, { PublicVarsInterface as SliderListCutSetupInterface } from '../../../libs/slider/slider-list-cut';
import scroll from '../../../libs/scroll/scroll';

import gsap from 'gsap';
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import router from '../../../libs/router/router';

interface OptionsInterface {
	cssId: {
		anim?: {
			aboutDamDirectorsContentSectionHeaderBigV2Cls: string;
			aboutDamManagementContentSectionHeaderBigV2Cls: string;
			aboutDamBoardBoardCarouselDirectorsCls: string;
			aboutDamBoardBoardCarouselManagementCls: string;
		}

		boardCarouselInfoLoadingCls?: string;
		boardCarouselSliderItemActiveCls?: string;
		headerCls?: string;
		aboutDamBoardBoardCarouselDirectorsSliderItemCls?: string;
		aboutDamBoardBoardCarouselDirectorsInfoId?: string;
		aboutDamBoardBoardCarouselDirectorsInfoContentHeaderId?: string;
		aboutDamBoardBoardCarouselDirectorsInfoContentSubheaderId?: string;
		aboutDamBoardBoardCarouselDirectorsInfoContentTextId?: string;
		aboutDamBoardBoardCarouselDirectorsInfoInnerId?: string;
		aboutDamBoardBoardCarouselDirectorsInfoImageId?: string;
		aboutDamBoardBoardCarouselDirectorsInfoSocialItemId?: string;
		aboutDamBoardBoardCarouselDirectorsSliderId?: string;
		aboutDamBoardBoardCarouselDirectorsSliderItemSocialCls?: string;

		aboutDamBoardBoardCarouselManagementSliderItemCls?: string;
		aboutDamBoardBoardCarouselManagementInfoId?: string;
		aboutDamBoardBoardCarouselManagementInfoContentHeaderId?: string;
		aboutDamBoardBoardCarouselManagementInfoContentSubheaderId?: string;
		aboutDamBoardBoardCarouselManagementInfoContentTextId?: string;
		aboutDamBoardBoardCarouselManagementInfoInnerId?: string;
		aboutDamBoardBoardCarouselManagementInfoImageId?: string;
		aboutDamBoardBoardCarouselManagementInfoSocialItemId?: string;
		aboutDamBoardBoardCarouselManagementSliderId?: string;
		aboutDamBoardBoardCarouselManagementSliderItemSocialCls?: string;
	},

	directorsSliderListCutSetup?: SliderListCutSetupInterface,
	managementSliderListCutSetup?: SliderListCutSetupInterface,

	baseUrl?: string,

	slug: string
}

class Board extends Module {

	publicVars: OptionsInterface;
	privateVars: {
		'directors': {
			currentSlug: string | null,
			infoAnim: boolean
		},
		'management': {
			currentSlug: string | null,
			infoAnim: boolean
		},
	};

	service: {
		sliderDirectors: ReturnType<typeof sliderListCutFactory.create> | null,
		sliderManagement: ReturnType<typeof sliderListCutFactory.create> | null,
	} = {
		sliderDirectors: null,
		sliderManagement: null,
	}

	constructor(options: OptionsInterface) {
		super('About Directors And Management Board Module');

		this.publicVars = options;

		this.privateVars = {
			'directors': {
				currentSlug: null,
				infoAnim: false
			},
			'management': {
				currentSlug: null,
				infoAnim: false
			}
		}
	}

	startup() {
		this.msg('startup');

		gsap.registerPlugin(ScrollToPlugin);

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.aboutDamDirectorsContentSectionHeaderBigV2Cls || '',
			'about_directors_and_management_board', { animCls: 'animate__zoomIn50P', once: true});

		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.aboutDamManagementContentSectionHeaderBigV2Cls || '',
			'about_directors_and_management_board', { animCls: 'animate__zoomIn50P', once: true});

		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.aboutDamBoardBoardCarouselDirectorsCls || '',
			'about_directors_and_management_board', { animCls: 'animate__fadeIn', once: true});

		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.aboutDamBoardBoardCarouselManagementCls || '',
			'about_directors_and_management_board', { animCls: 'animate__fadeIn', once: true});

		if(!this.publicVars.directorsSliderListCutSetup) {
			this.errorMsg('sliderSetup directors is not defined');
		} else {
			this.service.sliderDirectors = sliderListCutFactory.create();
			this.service.sliderDirectors.init(this.publicVars.directorsSliderListCutSetup);
		}

		if(!this.publicVars.managementSliderListCutSetup) {
			this.errorMsg('sliderSetup management is not defined');
		} else {
			this.service.sliderManagement = sliderListCutFactory.create();
			this.service.sliderManagement.init(this.publicVars.managementSliderListCutSetup);
		}
	}

	bind() {
		this.msg('bind');

		this.bindBoardCarouselItemEvent('Directors');
		this.bindBoardCarouselItemEvent('Management');

		if(this.publicVars.cssId.aboutDamBoardBoardCarouselDirectorsSliderItemSocialCls) {
			const sliderSocialDirectorsLinksHtml = document.querySelectorAll(this.publicVars.cssId.aboutDamBoardBoardCarouselDirectorsSliderItemSocialCls);

			sliderSocialDirectorsLinksHtml.forEach((elem) => {
				elem?.addEventListener('click', (e) => {
					e.stopPropagation();
				})
			})
		}

		if(this.publicVars.cssId.aboutDamBoardBoardCarouselManagementSliderItemSocialCls) {
			const sliderSocialManagementLinksHtml = document.querySelectorAll(this.publicVars.cssId.aboutDamBoardBoardCarouselManagementSliderItemSocialCls);

			sliderSocialManagementLinksHtml.forEach((elem) => {
				elem?.addEventListener('click', (e) => {
					e.stopPropagation();
				})
			})
		}
	}

	bindBoardCarouselItemEvent(type: 'Directors' | 'Management') {

		let itemCls = null;

		if(type === 'Directors') {
			itemCls = this.publicVars.cssId.aboutDamBoardBoardCarouselDirectorsSliderItemCls;
		} else {
			itemCls = this.publicVars.cssId.aboutDamBoardBoardCarouselManagementSliderItemCls;
		}


		if(itemCls) {
			const sliderItemHtml: NodeListOf<HTMLElement> = document.querySelectorAll(itemCls);

			const callbackOpenFunction = this.handleInfoOpen.bind(this);

			sliderItemHtml.forEach(item => {

				item.addEventListener('click', function(this: HTMLElement) {
					callbackOpenFunction(this, type)
				});
			})
		}
	}

	handleInfoOpen(elem: HTMLElement, type: 'Directors' | 'Management') {
		let typeLower: 'directors' | 'management' = type.toLowerCase() as 'directors' | 'management';

		if(this.privateVars[typeLower].infoAnim) {
			return;
		}

		if(!this.publicVars.cssId?.boardCarouselInfoLoadingCls
			|| !this.publicVars.cssId?.boardCarouselSliderItemActiveCls
			|| !this.publicVars.cssId?.aboutDamBoardBoardCarouselDirectorsInfoId
			|| !this.publicVars.cssId?.aboutDamBoardBoardCarouselDirectorsInfoContentHeaderId
			|| !this.publicVars.cssId?.aboutDamBoardBoardCarouselDirectorsInfoInnerId
			|| !this.publicVars.cssId?.aboutDamBoardBoardCarouselDirectorsInfoContentSubheaderId
			|| !this.publicVars.cssId?.aboutDamBoardBoardCarouselDirectorsInfoContentTextId
			|| !this.publicVars.cssId?.aboutDamBoardBoardCarouselDirectorsInfoImageId
			|| !this.publicVars.cssId?.aboutDamBoardBoardCarouselDirectorsInfoSocialItemId
			|| !this.publicVars.cssId?.aboutDamBoardBoardCarouselDirectorsSliderItemCls

			|| !this.publicVars.cssId?.aboutDamBoardBoardCarouselManagementInfoId
			|| !this.publicVars.cssId?.aboutDamBoardBoardCarouselManagementInfoContentHeaderId
			|| !this.publicVars.cssId?.aboutDamBoardBoardCarouselManagementInfoInnerId
			|| !this.publicVars.cssId?.aboutDamBoardBoardCarouselManagementInfoContentSubheaderId
			|| !this.publicVars.cssId?.aboutDamBoardBoardCarouselManagementInfoContentTextId
			|| !this.publicVars.cssId?.aboutDamBoardBoardCarouselManagementInfoImageId
			|| !this.publicVars.cssId?.aboutDamBoardBoardCarouselManagementInfoSocialItemId
			|| !this.publicVars.cssId?.aboutDamBoardBoardCarouselManagementSliderItemCls

		) {
			this.errorMsg('info classes config error');
			return;
		}

		if(elem.classList.contains(this.publicVars.cssId?.boardCarouselSliderItemActiveCls.substring(1))) {
			return;
		}

		if(this.publicVars?.baseUrl && elem.dataset?.slug && elem.dataset?.seo) {
			const routerUrl = this.publicVars.baseUrl + elem.dataset.slug + '/';

			router.route(routerUrl, elem.dataset.seo, {});
		}

		let sliderItemCls = null;
		let sliderCssId = null;
		let infoCssId = null;
		let infoHeaderCssId = null;
		let infoSubHeaderCssId = null;
		let infoTextCssId = null;
		let infoImageCssId = null;
		let infoSocialItemCssId = null;
		let infoInnerCssId = null;

		if(type === 'Directors') {
			sliderCssId = this.publicVars.cssId.aboutDamBoardBoardCarouselDirectorsSliderId;
			sliderItemCls = this.publicVars.cssId?.aboutDamBoardBoardCarouselDirectorsSliderItemCls;
			infoCssId = this.publicVars.cssId?.aboutDamBoardBoardCarouselDirectorsInfoId;
			infoHeaderCssId = this.publicVars.cssId?.aboutDamBoardBoardCarouselDirectorsInfoContentHeaderId;
			infoSubHeaderCssId = this.publicVars.cssId?.aboutDamBoardBoardCarouselDirectorsInfoContentSubheaderId;
			infoTextCssId = this.publicVars.cssId?.aboutDamBoardBoardCarouselDirectorsInfoContentTextId;
			infoImageCssId = this.publicVars.cssId?.aboutDamBoardBoardCarouselDirectorsInfoImageId;
			infoSocialItemCssId = this.publicVars.cssId?.aboutDamBoardBoardCarouselDirectorsInfoSocialItemId;
			infoInnerCssId = this.publicVars.cssId?.aboutDamBoardBoardCarouselDirectorsInfoInnerId;
			typeLower = 'directors';

		} else {
			sliderCssId = this.publicVars.cssId.aboutDamBoardBoardCarouselManagementSliderId;
			sliderItemCls = this.publicVars.cssId?.aboutDamBoardBoardCarouselManagementSliderItemCls;
			infoCssId = this.publicVars.cssId?.aboutDamBoardBoardCarouselManagementInfoId;
			infoHeaderCssId = this.publicVars.cssId?.aboutDamBoardBoardCarouselManagementInfoContentHeaderId;
			infoSubHeaderCssId = this.publicVars.cssId?.aboutDamBoardBoardCarouselManagementInfoContentSubheaderId;
			infoTextCssId = this.publicVars.cssId?.aboutDamBoardBoardCarouselManagementInfoContentTextId;
			infoImageCssId = this.publicVars.cssId?.aboutDamBoardBoardCarouselManagementInfoImageId;
			infoSocialItemCssId = this.publicVars.cssId?.aboutDamBoardBoardCarouselManagementInfoSocialItemId;
			infoInnerCssId = this.publicVars.cssId?.aboutDamBoardBoardCarouselManagementInfoInnerId;
			typeLower = 'management';
		}

		const boardCarouselItems = document.querySelectorAll(sliderItemCls);

		boardCarouselItems.forEach(item => {
			item?.classList.remove(this.publicVars.cssId?.boardCarouselSliderItemActiveCls!.substring(1) || '');

			if(item instanceof HTMLElement) {
				if(item.dataset.slug === elem.dataset.slug) {
					item.classList.add(this.publicVars.cssId?.boardCarouselSliderItemActiveCls!.substring(1) || '');
				}
			}
		});

		const infoHtml = document.querySelector(infoCssId) as HTMLElement;
		const infoHeaderHtml = document.querySelector(infoHeaderCssId) as HTMLElement;
		const infoSubHeaderHtml = document.querySelector(infoSubHeaderCssId) as HTMLElement;
		const infoTextHtml = document.querySelector(infoTextCssId) as HTMLElement;
		const infoImage = document.querySelector(infoImageCssId) as HTMLImageElement;
		const infoSocialItem = document.querySelector(infoSocialItemCssId) as HTMLLinkElement;


		this.privateVars[typeLower].infoAnim = true;

		const headerHeight = this.getHeaderHeight();

		const t = gsap.to(infoInnerCssId, {
			scale: 0.9,
			opacity: 0,
			duration: 0.3,
			ease: 'sineInOut',
			onComplete: () => {
				// infoHeaderHtml.textContent = elem.dataset['name'] || '';
				// infoSubHeaderHtml.textContent = elem.dataset['position'] || '';
				// infoTextHtml.textContent = elem.dataset['bio'] || '';
				//
				// t.reverse();

				const oldInfoHeight = infoHtml.offsetHeight;

				infoHtml?.classList.add(this.publicVars.cssId.boardCarouselInfoLoadingCls!.substring(1));
				infoHtml.style.height = oldInfoHeight + 'px';
				infoHtml.style.overflow = 'hidden';
				infoHeaderHtml.textContent = elem.dataset['name'] || '';
				infoSubHeaderHtml.textContent = elem.dataset['position'] || '';
				infoTextHtml.textContent = elem.dataset['bio'] || '';
				infoImage.src = elem.dataset['img.src'] || '';
				infoSocialItem.href = elem.dataset['link'] || '';


				infoHtml.style.overflow = 'visible';
				infoHtml.style.height = 'auto';

				const newInfoHtmlHeight = infoHtml.offsetHeight;

				const windowWidth = window.screen.width;



				gsap.to(window, {
					duration: 0.3,
					ease: 'power2.out',
					scrollTo: { y: windowWidth < 901 ? infoCssId : sliderCssId, offsetY: +headerHeight + 20 }
				});


				infoHtml.style.overflow = 'hidden';
				infoHtml.style.height = oldInfoHeight + 'px';

				gsap.to(infoCssId, {
					height: newInfoHtmlHeight + 'px',
					onComplete: () => {
						setTimeout(() => {
							infoHtml?.classList.remove(this.publicVars.cssId.boardCarouselInfoLoadingCls!.substring(1));
							t.reverse();
						}, 150);
					}
				})
			},
			onReverseComplete: () => {
				this.privateVars[typeLower].infoAnim = false;
				infoHtml.removeAttribute('style');
			}
		})

		// infoHtml?.classList.add(this.publicVars.cssId.boardCarouselInfoLoadingCls.substring(1));
		//
		// headerHtml.textContent = elem.dataset['name'] || '';
		//
		// setTimeout(() => {
		// 	infoHtml?.classList.remove(this.publicVars.cssId.boardCarouselInfoLoadingCls!.substring(1));
		// }, 1000);
	}

	getHeaderHeight() {
		let headerHeight = 0;

		if(this.publicVars.cssId.headerCls) {
			const header = document.querySelector(this.publicVars.cssId.headerCls) as HTMLElement;

			headerHeight = header?.offsetHeight || 0;
		}

		return headerHeight;
	}
}

export default Board;